import script from "./comment.vue?vue&type=script&setup=true&lang=ts"
export * from "./comment.vue?vue&type=script&setup=true&lang=ts"

import "./comment.vue?vue&type=style&index=0&id=21a0b077&lang=css"

const __exports__ = script;

export default __exports__